import { StyledForecast } from './Forecast.style';
import useForecast from './useForecast/useForecast';
import ForecastLoader from './ForecastLoader';
import ForecastHeader from './ForecastHeader';
import MonteCarloSimulation from './MonteCarloSimulation';
import useEmptyStateType from './EmptyState/useEmptyStateType';
import EmptyState from './EmptyState';
import useAmplitudeVisit from 'common/hooks/tracking/useAmplitudeVisit';
import { TRACKING } from 'common/constants/constants';

const Forecast = () => {
  const forecast = useForecast();
  const emptyStateType = useEmptyStateType({ forecast });
  useAmplitudeVisit({ page: TRACKING.PAGES.FORECAST });

  if (forecast.isLoading) return <ForecastLoader />;
  if (emptyStateType) return <EmptyState type={emptyStateType} />;

  return (
    <StyledForecast>
      <ForecastHeader forecast={forecast} />
      <MonteCarloSimulation forecast={forecast} />
    </StyledForecast>
  );
};

export default Forecast;
